import ContentLayout from '../../layout/ContentLayout';
import GenericTable from '../../components/tables/GenericTable';
import Pagination from '../../components/layout/Pagination';
import styles from '../../styles/referralProgram.module.scss';
import Search from 'antd/es/transfer/search';

const ReferralProgram = () => {
  const currentPage = 1;
  const totalPages = 6;
  const [search, setSearch] = '';
  const onSearch = (value) => {
    setSearch(value);
  };

  const onPageChange = (page) => {};

  const columns = [
    { key: 'firstLastName', label: 'Korisnik' },
    {
      key: 'referralLink',
      label: 'Referral link',
      render: (val, row) => {
        return (
          <a href="">
            <span className="primaryColor underline">{val}</span>
          </a>
        );
      },
    },
    { key: 'earnings', label: 'Iznos' },
    { key: 'addedPoints', label: 'Dodati poeni' },
  ];

  const data = [
    {
      firstLastName: 'Marko Marković',
      referralLink: 'sokovinemet.com/referral-434234234/',
      earnings: '2000',
      addedPoints: '+10 poena',
    },
    {
      firstLastName: 'Ivana Ivanović',
      referralLink: 'sokovinemet.com/referral-434234234/',
      earnings: '6000',
      addedPoints: '+20 poena',
    },
    {
      firstLastName: 'Marko Marković',
      referralLink: 'sokovinemet.com/referral-434234234/',
      earnings: '2000',
      addedPoints: '+10 poena',
    },
    {
      firstLastName: 'Ivana Ivanović',
      referralLink: 'sokovinemet.com/referral-434234234/',
      earnings: '6000',
      addedPoints: '+20 poena',
    },
    {
      firstLastName: 'Marko Marković',
      referralLink: 'sokovinemet.com/referral-434234234/',
      earnings: '2000',
      addedPoints: '+10 poena',
    },
    {
      firstLastName: 'Ivana Ivanović',
      referralLink: 'sokovinemet.com/referral-434234234/',
      earnings: '6000',
      addedPoints: '+20 poena',
    },
    {
      firstLastName: 'Marko Marković',
      referralLink: 'sokovinemet.com/referral-434234234/',
      earnings: '2000',
      addedPoints: '+10 poena',
    },
    {
      firstLastName: 'Ivana Ivanović',
      referralLink: 'sokovinemet.com/referral-434234234/',
      earnings: '6000',
      addedPoints: '+20 poena',
    },
    {
      firstLastName: 'Marko Marković',
      referralLink: 'sokovinemet.com/referral-434234234/',
      earnings: '2000',
      addedPoints: '+10 poena',
    },
    {
      firstLastName: 'Ivana Ivanović',
      referralLink: 'sokovinemet.com/referral-434234234/',
      earnings: '6000',
      addedPoints: '+20 poena',
    },
  ];

  return (
    <>
      <ContentLayout pt={true}>
        <div className={styles.refferral}>
          <div className={styles.header}>
            <p className="title">Referral program</p>
            <div>
              <Search
                placeholder={'Pretraži'}
                className="search-input"
                allowClear
                enterButton
                // onSearch={(value) => onSearch(value)}
                onChange={(e) => onSearch(e.target.value)}
                width="auto"
              />
            </div>
          </div>
          <div className={styles.body}>
            <GenericTable
              data={data}
              columns={columns}
              // actions={actions}
              // emptyState={emptyState}
            />
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>
        </div>
      </ContentLayout>
    </>
  );
};
export default ReferralProgram;
